<template>
	<v-app :dark="goDark" v-bind:class="{mediumFont: mediumSize, largeFont: largeSize}">
		<loader v-if="!isPrinting" class="no-print"/>
		<egranty-snackbar class="no-print"/>
		<router-view/>
	</v-app>
</template>

<script>
import Loader from "./view/components/loader";
import egrantySnackbar from "./genericComponents/EgrantySnackbar";

export default {
		name: "App",
		components: {egrantySnackbar, Loader},

		data() {
			return {
				interval: undefined,
				goDark: false,
				normalSize: false,
				mediumSize: false,
				largeSize: false,
				isPrinting: this.$route.path.includes("LrZ63OJBjtb4Iii5sBuRDC2X8JlygwCcIiehxloouW4RqqTtS0djoXr75zGeEUXh")
			};
		},

		created() {
			this.interval = setInterval(() => this.hackGenericForm(), 400);
			this.$messagesBus.$on("setContrast", this.setContrast);
			this.$messagesBus.$on("setFontSize", this.setFontSize);
		},

		mounted() {
			this.setContrastAndFontSize();
		},
		updated() {
			this.initMainTagPadding();
		},

		methods: {
      findElementsByClassRecursive(element, className) {
        let foundElements = [];

        if (element.classList && element.classList.contains(className)) {
          foundElements.push(element); // Add matching element to the array
        }

        const children = element.children;

        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          const childMatches = this.findElementsByClassRecursive(child, className);
          foundElements = foundElements.concat(childMatches);
        }

        return foundElements;
      },
			setCookie (key, value) {
				var expires = new Date();
				expires.setTime(expires.getTime() + 31536000000); //1 year
				document.cookie =
					key + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
			},
      hackGenericForm() {
        let listOfSelects = document.getElementsByClassName("field-checklist");
        for (let i = 0; i < listOfSelects.length; i++) {
          let selectElement = listOfSelects[i];
          let infoElement = this.findElementsByClassRecursive(selectElement, "info")[0];
          let foundExpanded = this.findElementsByClassRecursive(selectElement, "expanded")[0];

          if (!infoElement) {
            continue; // this is a radio list, not expandable
          }

          if (foundExpanded) {
            let n = this.findElementsByClassRecursive(selectElement, "is-checked").length;
            infoElement.textContent = "Wybierz (wybrano: " + n + ")";
          } else if (infoElement && (infoElement.textContent.includes("selected") || infoElement.textContent.includes("wybrano"))) {
            let n = Number(infoElement.textContent.replace(/[^0-9]/g, ''));
            infoElement.textContent = "Wybierz (wybrano: " + n + ")";
          } else {
            infoElement.textContent = "";
          }
        }
      },
			setContrast (contrast) {
				this.setCookie("contrast", contrast);
				if (contrast === "high") {
					return (this.goDark = true);
				} else {
					return (this.goDark = false);
				}
			},
			setFontSize (size) {
				this.setCookie("fontSize", size);
				if (size === "normal") {
					this.normalSize = false;
					this.mediumSize = false;
					this.largeSize = false;
					this.mainTagPadding();

				}
				if (size === "medium") {
					this.normalSize = false;
					this.mediumSize = true;
					this.largeSize = false;
					this.mainTagPadding();
				}
				if (size === "large") {
					this.normalSize = false;
					this.mediumSize = false;
					this.largeSize = true;
					this.mainTagPadding();
				}
			},
			setContrastAndFontSize () {
				let contrast = this.getCookie("contrast");
				this.setContrast(contrast);
				let size = this.getCookie("fontSize");
				this.setFontSize(size);
			},
			getCookie (key) {
				let keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
				return keyValue ? keyValue[2] : null;
			},
			initMainTagPadding() {
				var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
				setTimeout(()=> {
					if (!document.getElementsByClassName('navigation-top')[0]) return;
					var navHeight = document.getElementsByClassName('navigation-top')[0].clientHeight;
					if (isIE11) {
						document.getElementById('main').style.paddingTop = navHeight + 'px';
						return false;
					}
					document.getElementById('main').style.paddingTop = '0';
				}, 1000);
			},
			mainTagPadding() {
				var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
				setTimeout(()=> {
					if (!document.getElementsByClassName('navigation-top')[0]) return;
					var navHeight = document.getElementsByClassName('navigation-top')[0].clientHeight;
					if (isIE11) {
						document.getElementById('main').style.paddingTop = navHeight + 'px';
						return false;
					}
					document.getElementById('main').style.paddingTop = '0';
				}, 350);
			},
		},
	};
</script>

<style>
	@import './view/logged/assets/css/style-for-print.css';
	@import './assets/css/contrast-font-size.css';
	/* latin-ext */
	@font-face {
		font-family: 'Open Sans';
		font-style: normal;
		font-weight: 700;
		font-display: swap;
		src: local('Open Sans Bold'), local('OpenSans-Bold'), url(./assets/fonts/OpenSans-Bold.ttf) format('truetype');
		unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}

	/* latin */
	@font-face {
		font-family: 'Open Sans';
		font-style: normal;
		font-weight: 700;
		font-display: swap;
		src: local('Open Sans Bold'), local('OpenSans-Bold'), url(./assets/fonts/OpenSans-Bold.ttf) format('truetype');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}

	/* latin-ext */
	@font-face {
		font-family: 'Open Sans';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src: local('Open Sans Regular'), local('OpenSans-Regular'), url(./assets/fonts/OpenSans-Regular.ttf) format('truetype');
		unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}

	/* latin */
	@font-face {
		font-family: 'Open Sans';
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src: local('Open Sans Regular'), local('OpenSans-Regular'), url(./assets/fonts/OpenSans-Regular.ttf) format('truetype');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}

	/* latin-ext */
	@font-face {
		font-family: 'Open Sans';
		font-style: italic;
		font-weight: 700;
		font-display: swap;
		src: local('Open Sans Bold Italic'), local('OpenSans-BoldItalic'), url(./assets/fonts/OpenSans-BoldItalic.ttf) format('truetype');
		unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}

	/* latin */
	@font-face {
		font-family: 'Open Sans';
		font-style: italic;
		font-weight: 700;
		font-display: swap;
		src: local('Open Sans Bold Italic'), local('OpenSans-BoldItalic'), url(./assets/fonts/OpenSans-BoldItalic.ttf) format('truetype');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}

	/* latin-ext */
	@font-face {
		font-family: 'Open Sans';
		font-style: italic;
		font-weight: 400;
		font-display: swap;
		src: local('Open Sans Italic'), local('OpenSans-Italic'), url(./assets/fonts/OpenSans-Italic.ttf) format('truetype');
		unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
	}

	/* latin */
	@font-face {
		font-family: 'Open Sans';
		font-style: italic;
		font-weight: 400;
		font-display: swap;
		src: local('Open Sans Italic'), local('OpenSans-Italic'), url(./assets/fonts/OpenSans-Italic.ttf) format('truetype');
		unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
	}

	.application--wrap {
		width: 100%;
	}
</style>

